import { httpClient } from '@/httpClient/axios.ts';
import Cookies from 'js-cookie';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';

export const useConfirmRequest = () => {
  const meta = useAppConfig();

  const confirm = (gridId: string) => {
    if (!meta) {
      return Promise.reject();
    }

    const url = `${meta.api.registrationsConfirmation}/${gridId}`;
    const headers = {
      'X-CSRFToken': Cookies.get('csrftoken'),
    };

    return httpClient.get(url, {
      headers: headers,
    });
  };

  return { confirm };
};
